import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { type FC } from "react";
import { AppRadio, RadioGroup } from "@/shared/Components";
import type { RadioGroupProps } from "antd/lib";
import styles from "../styles.module.scss";

type Props = RadioGroupProps & {
  onMenuChange: (sortType: MenuSorterOptions) => void;
  sorterMenuValue: MenuSorterOptions;
};

export type MenuSorterOptions = keyof typeof MENU_SORTER_OPTIONS | null;

export const MENU_SORTER_OPTIONS = {
  NAME_ASC: "NAME_ASC",
  NAME_DESC: "NAME_DESC",
  SECOND_NAME_ASC: "SECOND_NAME_ASC",
  SECOND_NAME_DESC: "SECOND_NAME_SESC",
  TITLE_ASC: "TITLE_ASC",
  TITLE_DESC: "TITLE_DESC",
};

export const MenuSorterList: FC<Props> = ({ onMenuChange, sorterMenuValue, ...props }) => {
  const { t } = useTranslation();

  const onChange = (value: MenuSorterOptions) => {
    onMenuChange(value);
  };

  const clearValue = () => {
    onMenuChange(null);
  };

  return (
    <div className={classNames(styles.container)}>
      <RadioGroup
        value={sorterMenuValue}
        className={styles.radio}
        onChange={(e) => onChange(e.target.value)}
        {...props}
      >
        <AppRadio onClick={clearValue} value={MENU_SORTER_OPTIONS.NAME_ASC}>
          {t("common.byNameAsc")}
        </AppRadio>
        <AppRadio onClick={clearValue} value={MENU_SORTER_OPTIONS.NAME_DESC}>
          {t("common.byNameDesc")}
        </AppRadio>
        <AppRadio onClick={clearValue} value={MENU_SORTER_OPTIONS.SECOND_NAME_ASC}>
          {t("common.bySecondNameAsc")}
        </AppRadio>
        <AppRadio onClick={clearValue} value={MENU_SORTER_OPTIONS.SECOND_NAME_DESC}>
          {t("common.bySecondNameDesc")}
        </AppRadio>
        <AppRadio onClick={clearValue} value={MENU_SORTER_OPTIONS.TITLE_ASC}>
          {t("common.byTitleAsc")}
        </AppRadio>
        <AppRadio onClick={clearValue} value={MENU_SORTER_OPTIONS.TITLE_DESC}>
          {t("common.byTitleDesc")}
        </AppRadio>
      </RadioGroup>
    </div>
  );
};
